import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class RouteAccessGuard implements CanActivateChild {

  constructor(private auth_service: AuthService, private router: Router) {}

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const targetRoute = route.routeConfig?.path || '';
    console.log('Checking child route access:', targetRoute);

    if (this.auth_service.canAccessRoute(targetRoute)) {
      return true;
    } else {
      console.warn('Access denied to:', targetRoute);
      this.router.navigate(['/admin']); // fallback route
      return false;
    }
  }
}
